
import { MapConfig } from 'lib-customizations/types'

const mapConfig: MapConfig = {
  center: [60.21250, 24.72867],
  initialZoom: 13,
  addressZoom: 14,
  searchAreaRect: {
    maxLatitude: 60.512502366382154,
    minLatitude: 60.012502366382154,
    maxLongitude: 25.028676089762896,
    minLongitude: 24.528676089762896,
  },
  careTypeFilters: ['DAYCARE', 'PRESCHOOL', 'CLUB'],
  unitProviderTypeFilters: [
    'MUNICIPAL',
    'PURCHASED',
    'PRIVATE',
    'PRIVATE_SERVICE_VOUCHER',
  ],
}

export default mapConfig
